"use client";
import React, { useState, useEffect } from "react";
import cn from "clsx";
import { useTranslations } from "next-intl";
import { Skeleton, TabNav, Text } from "@radix-ui/themes";
import { SectionProps } from "@/components/common/interface/interfaces";
import Link from "next/link";
import { appRouterPush, getPrefetch, isAndroidRouter } from "@/util/apputil";
import { useRouter } from "next/navigation";

// When the user is on `/en`, this will be `/`
export interface TextLinkType {
  title: string;
  trans?: string;
  link?: string;
  loading?: boolean;
  active?: boolean;
}

const defaultCN = "";
export default function TabItem({
  link,
  loading,
  active,
  props,
}: {
  link: TextLinkType;
  loading: boolean;
  active: boolean;
  props: SectionProps;
}) {
  const t = useTranslations("tab");
  const prefetch = getPrefetch();
  const router = useRouter();
  if ((link.title ?? "") != "") {
    link.trans = t(link.title);
  }

  return (
    <TabNav.Link asChild className={cn(defaultCN, "hover:animate-pulse hover:animate-infinit hover:animate-duration-1000")} active={active}>
      <Link
        href={props.pathname + (link.link ?? "#")}
        aria-label={link.link}
        title={link.trans}
        prefetch={prefetch}
        onClick={
          isAndroidRouter()
            ? (e) => {
                e.preventDefault();
                // router.push(props.pathname + (link.link ?? "#"));
                appRouterPush(router,props?.pathname + (link.link ?? "#"));
                // window.location.href = props?.pathname + (link.link ?? "#");
              }
            : undefined
        }
      >
        <Skeleton loading={loading}>
          <Text as="div">{link.trans}</Text>
        </Skeleton>
      </Link>
    </TabNav.Link>
  );
}
